import { GetMyCommonTaskMembersResponse } from '@/shared/types/post/responses/GetMyCommonTaskMembersResponse'

import { UpdatePostCommentRequest } from '../../../types/post/requests/UpdatePostCommentRequest'
import { UpdatePostRequest } from '../../../types/post/requests/UpdatePostRequest'
import { GetMyCommonGroupMembersResponse } from '../../../types/post/responses/GetMyCommonGroupMembersResponse'
import { PostCommentForFeedResponse } from '../../../types/post/responses/PostCommentForFeedResponse'
import { UpdatePostResponse } from '../../../types/post/responses/UpdatePostResponse'
import { ApiException } from '../Api-exception'
import { axios, Response } from '../index'

export const editPost = (
  companyId: string,
  personaType: string,
  personaId: string,
  postId: number | string,
  request: UpdatePostRequest
): Response<UpdatePostResponse> => {
  try {
    return axios.put(`/v2/posts/${postId}`, request, {
      headers: {
        'X-CompanyID': companyId,
        'X-PersonaType': personaType,
        'X-PersonaID': personaId
      }
    })
  } catch (error: unknown) {
    throw new ApiException(
      (error as { message?: string }).message || 'Erro ao editar a postagem.'
    )
  }
}

export const editPostComment = (
  postId: number,
  postCommentId: number,
  request: UpdatePostCommentRequest
): Response<PostCommentForFeedResponse> => {
  try {
    return axios.put(`/v6/posts/${postId}/comments/${postCommentId}`, request)
  } catch (error: unknown) {
    throw new ApiException(
      (error as { message?: string }).message || 'Erro ao editar comentário.'
    )
  }
}

export const deletePostComment = (
  postCommentId: number | string,
  postId: string | number
): Response<void> => {
  try {
    return axios.delete(`/v1/posts/${postId}/comments/${postCommentId}`)
  } catch (error: unknown) {
    throw new ApiException(
      (error as { message?: string }).message || 'Erro ao deletar comentário.'
    )
  }
}

export const getMyCommonGroupMembers = (
  personaId: string
): Response<GetMyCommonGroupMembersResponse[]> => {
  try {
    return axios.get(`/v1/personas/${personaId}/common-members`)
  } catch (error: unknown) {
    throw new ApiException(
      (error as { message?: string }).message ||
        'Erro ao obter as personas comuns do grupo.'
    )
  }
}

export const getMyCommonGroupMembersWithCurrentPerson = (
  personaId: string
): Response<GetMyCommonTaskMembersResponse[]> => {
  try {
    return axios.get(`/v1/personas/${personaId}/tasks/common-members`)
  } catch (error: unknown) {
    throw new ApiException(
      (error as { message?: string }).message ||
        'Erro ao obter as personas comuns do grupo.'
    )
  }
}
